import axios from 'axios';
import storeUtils from '@/store/storeUtils';
import mixin from '@/mixins/mixin';
import { debounce } from 'lodash';
import Vue from 'vue';

const getSectionById = (template, sectionId) => {
  let result;
  template.data.sections.forEach((section) => {
    if (section.sections) {
      section.sections.forEach((sect) => {
        if (sect.id === sectionId) {
          result = sect;
        }
      });
    }
    if (section.id === sectionId) {
      result = section;
    }
  });
  return result;
};

// eslint-disable-next-line
const expandTemplate = (template) => {
  // normalize
  template.data.divisions[0].sectionResources.forEach((sectionResource) => {
    // eslint-disable-next-line
    sectionResource.isEdited = false;
    if (typeof sectionResource.coreResource !== 'object') {
      // eslint-disable-next-line
      const coreResource = template.data.coreResources.find(coreResource => {
        return coreResource.id === sectionResource.coreResource;
      });
      if (!coreResource) {
        console.log(`... couldn't find core resource with id ${coreResource}`);
      }
      // eslint-disable-next-line
      sectionResource.coreResource = coreResource;

      // search for formulas
      sectionResource.flows.forEach((flow) => {
        // eslint-disable-next-line
        const formula = template.data.formulas.find(formula => formula.id === flow.formula);
        if (formula) {
          // eslint-disable-next-line
          flow.formula = formula;
          const defaultCurrency = template.data.coreResources.find((cr) => cr.rel === 'currency' && cr.isDefault);

          // eslint-disable-next-line
          flow.fcst.forEach((f, index) => {
            const { isCurrency } = flow.formula.variables[index];
            if (isCurrency) {
              // eslint-disable-next-line
              f.scenarios[0].units = defaultCurrency;
            }
          });
        } else {
          console.log('formula not found', flow.formula);
        }
      });
    }
  });

  template.data.env.sectionResources.forEach((sectionResource) => {
    // eslint-disable-next-line
    sectionResource.isEdited = false;
    if (typeof sectionResource.coreResource !== 'object') {
      // eslint-disable-next-line
      const coreResource = template.data.coreResources.find(coreResource => {
        return coreResource.id === sectionResource.coreResource;
      });
      // eslint-disable-next-line
      sectionResource.coreResource = coreResource;
      // eslint-disable-next-line
      sectionResource.flows[0].formula = template.data.formulas.find(formula => formula.id === sectionResource.flows[0].formula);
    }
  });
  // end normalize

  // eslint-disable-next-line
  template.expanded = true;

  return template;
};

const createSection = (cfg) => {
  const { template, module } = cfg;
  const { sections } = template.data;
  const newSectionCfg = JSON.parse(JSON.stringify(module.templateSectionCfg));
  newSectionCfg.isEnabled = false;
  sections.push(newSectionCfg);
  // commit('updateState', {
  //   path: 'activeTemplate.data.sections',
  //   value: sections,
  // });
  console.log(`... section added ${module.templateSectionCfg.id}`);
  return template;
};

const getDefaultTemplate = (rootState, hideName) => {
  let template;
  // TODO - remove below
  // eslint-disable-next-line
  if (true) {
    console.log('...using default template');
    // create template off default
    // eslint-disable-next-line
    template = JSON.parse(JSON.stringify(rootState.defaultTemplateConfig));
    // get template language from the user language
    template.language = rootState.user.settings.language;
    // eslint-disable-next-line
    template.name = hideName ? '' : mixin.methods.translate(template.name, template.language, rootState);

    // translate core resources names
    template.data.coreResources.forEach((cr) => {
      // eslint-disable-next-line
      cr.name = mixin.methods.translate(cr.name, template.language, rootState);
    });

    // translate formula names
    template.data.formulas.forEach((f) => {
      // eslint-disable-next-line
      f.name = mixin.methods.translate(f.name, template.language, rootState);
    });
    template.timestamp = Date.now();
  } else {
    // retrieve template by id
    console.log('looking for specific template');
    // eslint-disable-next-line
    // activeTemplate = this.getTemplateById(templateId, state);
  }
  /*
  if (activeTemplate) {
    // normalize
    activeTemplate.data.divisions[0].sectionResources.forEach((sectionResource) => {
      // eslint-disable-next-line
      sectionResource.isEdited = false;
      if (typeof sectionResource.coreResource !== 'object') {
        // eslint-disable-next-line
        const coreResource = activeTemplate.data.coreResources.find(coreResource => {
          return coreResource.id === sectionResource.coreResource;
        });
        // eslint-disable-next-line
        sectionResource.coreResource = coreResource;

        // search for formulas
        sectionResource.flows.forEach((flow) => {
          // eslint-disable-next-line
          const formula = activeTemplate.data.formulas.find(formula => formula.id === flow.formula);
          if (formula) {
            // eslint-disable-next-line
            flow.formula = formula;
            const defaultCurrency = activeTemplate.data.coreResources.find((cr) => cr.rel === 'currency' && cr.isDefault);

            // eslint-disable-next-line
            flow.fcst.forEach((f, index) => {
              // const { isCurrency } = flow.formula.inputVariables[index];
              const { isCurrency } = flow.formula.variables[index];
              if (isCurrency) {
                // eslint-disable-next-line
                f.scenarios[0].units = defaultCurrency;
              }
            });
          } else {
            console.log(`formula ${flow.formula} not found`);
          }
        });
      }
    });

    activeTemplate.data.env.sectionResources.forEach((sectionResource) => {
      // eslint-disable-next-line
      sectionResource.isEdited = false;
      if (typeof sectionResource.coreResource !== 'object') {
        // eslint-disable-next-line
        const coreResource = activeTemplate.data.coreResources.find(coreResource => {
          return coreResource.id === sectionResource.coreResource;
        });
        // eslint-disable-next-line
        sectionResource.coreResource = coreResource;
        // eslint-disable-next-line
        sectionResource.flows[0].formula = activeTemplate.data.formulas.find(formula => formula.id === sectionResource.flows[0].formula);
      }
    });
    // end normalize


    // normalize sections data
    // eslint-disable-next-line
    const { sections } = activeTemplate.data;
    sections.forEach((section) => {
      if (typeof section.coreResourceTypes !== 'undefined') {
        // eslint-disable-next-line
        section.sectionResources = activeTemplate.data.divisions[0].sectionResources.filter((sectionResource) => {
          return section.coreResourceTypes.includes(sectionResource.coreResource.rel);
        });
      }

      // check for sub-sections in env
      if (section.sections) {
        // eslint-disable-next-line
        section.sections.forEach((section) => {
          // eslint-disable-next-line
          section.sectionResources = activeTemplate.data.env.sectionResources.filter((sectionResource) => {
            return section.coreResourceTypes.includes(sectionResource.coreResource.rel);
          });
          // eslint-disable-next-line
          section.isEditingSettings = false;
        });
      }
    });

      activeTemplate.expanded = true;
    } else {
      // shouldn't get here because already checked this
      console.error('Default or requested template not found');
    }

   */

  if (!template.uuid) {
    template.uuid = mixin.methods.uuidv4();
  }

  if (typeof template.data.openAIPrompt === 'undefined') {
    // eslint-disable-next-line
    template.data.openAIPrompt = mixin.methods.translate('ui_dialog_onboarding__business_category_placeholder', null, rootState);
  }

  return template;
};

const checkToUpgradeTemplate = (template, rootState) => {
  // let needSaving = false;
  const needsUpdating = !template.version;
  if (needsUpdating) {
    // needSaving = true;
    if (!template.uuid) {
      // eslint-disable-next-line
      template.uuid = mixin.methods.uuidv4();
    }
    const defaultTemplateLanguage = rootState.user.settings.language;
    if (!defaultTemplateLanguage) {
      // eslint-disable-next-line
      console.warn(`...template ${template.uuid} is likely broken`);
    } else {
      // eslint-disable-next-line
      template.language = defaultTemplateLanguage;//'en';
      // eslint-disable-next-line
      template.timestamp = new Date();
      // eslint-disable-next-line
      const defaultSections = JSON.parse(JSON.stringify(rootState.defaultTemplateConfig.data.sections));
      // eslint-disable-next-line
      template.data.sections = defaultSections;

      // update sections status
      template.data.sections.forEach((section) => {
        // eslint-disable-next-line
        section.isInitialized = true;
        // eslint-disable-next-line
        section.isVisible = true;
        // eslint-disable-next-line
        section.isEditingSettings = false;
      });
      // eslint-disable-next-line
      template.data.options.modules = JSON.parse(JSON.stringify(rootState.defaultTemplateConfig.data.options.modules));

      // eslint-disable-next-line
      template.version = "1.0";

      // template.data.formulas.forEach((f) => {
      //   // eslint-disable-next-line
      //   f.variables = f.inputVariables;
      //   // eslint-disable-next-line
      //   f.inputVariables = f.variables.map((v) => {
      //     return {
      //       id: v.id,
      //     };
      //   });
      // });
      // eslint-disable-next-line
      template.layout.cLeftColCount = parseInt(template.layout.cLeftColCount);
      // eslint-disable-next-line
      template.layout.cRightColCount = parseInt(template.layout.cLeftColCount);
      // eslint-disable-next-line
      template.layout.cHistColCount = parseInt(template.layout.cHistColCount);
      // eslint-disable-next-line
      template.layout.cFcstColCount = parseInt(template.layout.cFcstColCount);
      // eslint-disable-next-line
      template.layout.sheetPerModule = parseInt(template.layout.sheetPerModule);
    }
  }

  template.data.sections.forEach((section) => {
    if (section.sectionResources && !section.suggestedResources && section.id !== 'section_financing') {
      // eslint-disable-next-line
      section.suggestedResources = [];
    }
    if (typeof section.isEditingSettings === 'undefined') {
      // eslint-disable-next-line
      section.isEditingSettings = false;
    }
    if (typeof section.isCollapsed === 'undefined') {
      // eslint-disable-next-line
      section.isCollapsed = false;
    }
    const defaultSectionConfig = rootState.defaultTemplateConfig.data.sections.find((s) => s.id === section.id);
    if (!section.icon && rootState.defaultTemplateConfig) {
      if (defaultSectionConfig) {
        // eslint-disable-next-line
        section.icon = defaultSectionConfig.icon;
        // console.log(section.id);
        // eslint-disable-next-line
        section.isCollapsed = false;
      }
    }
    // replace cogs with cos
    if (section.coreResourceTypes && section.coreResourceTypes.includes('cogs')) {
      // eslint-disable-next-line
      section.coreResourceTypes = section.coreResourceTypes.filter((rel) => rel !== 'cogs');
      section.coreResourceTypes.push('cos');
    }

    // update section default settings
    if (defaultSectionConfig) {
      // eslint-disable-next-line
      section.coreResourceTypes = defaultSectionConfig.coreResourceTypes;
    }

    // enable each section since it's now managed on the module level
    if (!section.isEnabled) {
      // eslint-disable-next-line
      section.isEnabled = true;
    }
  });

  // check if default template has more and need to add to the template
  rootState.defaultTemplateConfig.data.sections.forEach((section) => {
    if (!template.data.sections.find((templateSection) => section.id === templateSection.id)) {
      const newSectionCfg = JSON.parse(JSON.stringify(section));
      newSectionCfg.isEnabled = false;
      // eslint-disable-next-line
      template.data.sections.push(newSectionCfg);
    }
  });


  if (typeof template.data.activeSectionId === 'undefined') {
    // eslint-disable-next-line
    template.data.activeSectionId = 'section_sales';
  }

  // set isNavigatorVisible to true by default
  if (typeof template.isNavigatorVisible === 'undefined') {
    // eslint-disable-next-line
    template.isNavigatorVisible = false;
  }
  // set isOnboardingComplete to true by default
  if (typeof template.isOnboardingComplete === 'undefined') {
    // eslint-disable-next-line
    template.isOnboardingComplete = true;
  }

  // add new formulas
  rootState.defaultTemplateConfig.data.formulas.forEach((formula) => {
    if (!template.data.formulas.find((templateFormula) => templateFormula.id === formula.id)) {
      // eslint-disable-next-line
      template.data.formulas.push(formula);
    }
  });

  // patch older loans to add commitment
  template.data.divisions[0].sectionResources.forEach((sectionResource) => {
    // console.log(sectionResource.otherAssumptions.commitment);
    const coreResource = typeof sectionResource.coreResource === 'string' ? template.data.coreResources.find((cr) => cr.id === sectionResource.coreResource) : sectionResource.coreResource;
    if (coreResource.rel === 'loan') {
      if (!sectionResource.otherAssumptions.commitment) {
        // eslint-disable-next-line
        sectionResource.otherAssumptions.commitment = {
          type: 'percent',
          name: 'input_resource_options_commitmentpercent',
          value: '100',
          units: 'percent',
        };
      } else if (!sectionResource.otherAssumptions.commitment.value) {
        // eslint-disable-next-line
        sectionResource.otherAssumptions.commitment.value = '100';
      }
    }
  });

  const modules = JSON.parse(JSON.stringify(rootState.defaultTemplateConfig.data.modules));
  // add modules that don't exist
  if (typeof template.data.modules === 'undefined') {
    // make sure all are initialized
    modules.forEach((m) => {
      // eslint-disable-next-line
      m.isInitialized = true;
    });
    // eslint-disable-next-line
    template.data.modules = modules;
  } else {
    // check if need to update any existing modules
    const upgradeableFields = ['nameLong'];
    template.data.modules.forEach(async (templateModule) => {
      const defaultModule = modules.find((m) => m.id === templateModule.id);
      if (defaultModule) {
        upgradeableFields.forEach((upgradeableField) => {
          // eslint-disable-next-line
          templateModule[upgradeableField] = defaultModule[upgradeableField];
        });
        // TODO - check the below
        // eslint-disable-next-line
        templateModule.isInitialized = true;
      }
      if (templateModule.isNew) {
        // eslint-disable-next-line
        templateModule.isNew = false;
      }
      // add section if missing
      if (templateModule.templateSectionCfg && !getSectionById(template, templateModule.templateSectionCfg.id)) {
        // eslint-disable-next-line
        template = createSection({
          template,
          module: templateModule,
        });
      }
    });
    // check if there are any to remove
    // eslint-disable-next-line
    template.data.modules = template.data.modules.filter((tm) => modules.find((m) => m.id === tm.id));
    // check if there are any new to add, following the default module order
    modules.forEach((m, index) => {
      if (!template.data.modules.find((tm) => tm.id === m.id)) {
        // eslint-disable-next-line
        m.isInitialized = true;
        // eslint-disable-next-line
        m.isNew = true;
        template.data.modules.splice(index, 0, m);
        // add a new section if needed
        this.createSection(m);
      }
    });
  }
  // mplate = checks.tem
  // state

  return template;
};

const hydrateTemplate = (template) => {
  // normalize
  template.data.divisions[0].sectionResources.forEach((sectionResource) => {
    // eslint-disable-next-line
    sectionResource.isEdited = false;
    if (typeof sectionResource.coreResource !== 'object') {
      // eslint-disable-next-line
      const coreResource = template.data.coreResources.find(coreResource => {
        return coreResource.id === sectionResource.coreResource;
      });
      if (!coreResource) {
        console.log(`... couldn't find core resource with id ${coreResource}`);
      }
      // eslint-disable-next-line
      sectionResource.coreResource = coreResource;

      // search for formulas
      sectionResource.flows.forEach((flow) => {
        // eslint-disable-next-line
        const formula = template.data.formulas.find(formula => formula.id === flow.formula);
        if (formula) {
          // eslint-disable-next-line
          flow.formula = formula;
          const defaultCurrency = template.data.coreResources.find((cr) => cr.rel === 'currency' && cr.isDefault);

          // eslint-disable-next-line
          flow.fcst.forEach((f, index) => {
            const { isCurrency } = flow.formula.variables[index];
            if (isCurrency) {
              // eslint-disable-next-line
              f.scenarios[0].units = defaultCurrency;
            }
          });
        } else {
          console.log('formula not found', flow.formula);
        }
      });
    }
  });

  template.data.env.sectionResources.forEach((sectionResource) => {
    // eslint-disable-next-line
    sectionResource.isEdited = false;
    if (typeof sectionResource.coreResource !== 'object') {
      // eslint-disable-next-line
      const coreResource = template.data.coreResources.find(coreResource => {
        return coreResource.id === sectionResource.coreResource;
      });
      // eslint-disable-next-line
      sectionResource.coreResource = coreResource;
      // eslint-disable-next-line
      sectionResource.flows[0].formula = template.data.formulas.find(formula => formula.id === sectionResource.flows[0].formula);
    }
  });
  // end normalize

  // eslint-disable-next-line
  template.hydrated = true;

  return template;
};

/*
const updatePreviewDataHTML = (modules, data) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  modules.forEach((module) => {
    // TODO - make it a flag
    if (module.id !== 'module_name_assumptions') {
      const rawSectionHTML = data[module.id];
      if (rawSectionHTML) {
        let rowsArr = rawSectionHTML.split(/<\/tr>/g);
        rowsArr = rowsArr.map((row) => {
          let arr = row.split(/(>-?\d+\.?[\dE-]*?<)/);
          if (arr.length > 1) {
            // eslint-disable-next-line
            arr = arr.map((item) => {
              let result = item;
              if (result.match(/>-?\d+\.?[\dE-]*?</g)) {
                result = result.replace(/[><]/g, '');
                // eslint-disable-next-line
                if (!isNaN(result)) {
                  const dateRowsSelectors = ['inputStartDate', 'contentIndent0date'];
                  if (dateRowsSelectors.some((selector) => row.includes(selector))) {
                    const dateInMs = Number(result) * 1000 * 60 * 60 * 24;
                    const epochFrom1900inMS = 2209075200000;
                    const dateInJsMs = dateInMs - epochFrom1900inMS;
                    result = `>${new Date(dateInJsMs).toLocaleDateString()}<`;
                  } else {
                    if (Math.abs(result) < 1e-3) {
                      result = 0;
                    }
                    result = `>${formatter.format(result)}<`;
                  }
                }
              }
              return result;
            });
          }
          // eslint-disable-next-line
          row = arr.join('');
          return row;
        });
        // eslint-disable-next-line
        module.previewCfg.previewHTML = rowsArr.join('</tr>');
        // eslint-disable-next-line
        module.previewCfg.isUpdating = false;
      } else {
        debugger;
        console.warn(`... html for ${module.id} not found`);
      }
    }
  });
  return modules;
};
*/

export default {
  state: () => ({
    template: {},
  }),
  mutations: {},
  actions: {
    updatePreviewDataHTML({ commit, rootState }, previewData) {
      const { modules } = rootState.activeTemplate.data;
      modules.forEach((module) => {
        // eslint-disable-next-line
        module.previewCfg.previewHTML = previewData[module.id];
      });
      commit('updateState', {
        path: 'activeTemplate.data.modules',
        value: modules,
      });
    },
    resetActiveTemplate({ commit, rootState }) {
      const template = getDefaultTemplate(rootState, true);
      commit('updateState', {
        path: 'activeTemplate',
        value: template,
      });
    },
    async removeTemplate({ commit, dispatch, rootState }, cfg) {
      const { template, skipPrompt } = cfg;
      const confirm = skipPrompt ? true : window.confirm(mixin.methods.translate('ui_confirm_delete', null, rootState));
      let result;
      if (confirm) {
        // const response = await axios.delete(`/api/template/${template.uuid}`);
        // eslint-disable-next-line
        const userId = rootState.user._id;
        const response = await axios.delete(`/api/user/${userId}/template/${template.uuid}`);
        result = response.data;
        console.log(result);

        if (result) {
          // remove from gallery
          // const templateIndex = rootState.user.templates.findIndex((userTemplate) => userTemplate.uuid === template.uuid);
          // rootState.user.templates.splice(templateIndex, 1);
          // commit('updateState', {
          //   path: 'user.templates',
          //   value: rootState.user.templates,
          // });
          commit('updateState', {
            path: 'user.templates',
            value: result,
          });


          // clear activeTemplate if has same id
          if (rootState.activeTemplate && rootState.activeTemplate.uuid === template.uuid) {
            dispatch('resetActiveTemplate');
          }

          // if on a property page - redirect to all templates
          // eslint-disable-next-line
          if (this._vm.router.currentRoute.name === 'template') {
            // eslint-disable-next-line
            this._vm.router.push('/templates');
          }
        }
      }
      return result;

      /*
      const templateIndex = rootState.user.templates.findIndex((userTemplate) => userTemplate.uuid === template.uuid);
      // eslint-disable-next-line
      const confirm = window.confirm(mixin.methods.translate('ui_confirm_delete', null, rootState));
      if (confirm) {
        const templateRemoved = rootState.user.templates.splice(templateIndex, 1)[0];
        commit('updateState', {
          path: 'user.templates',
          value: rootState.user.templates,
        });
        const dontAddMissing = true;
        this.dispatch('saveUser', dontAddMissing);

        // clear activeTemplate if has same id
        if (rootState.activeTemplate && rootState.activeTemplate.id === templateRemoved.id) {
        //   commit('updateState', {
        //     path: 'activeTemplate',
        //     value: null,
        //   });
        }

        // if on a property page - redirect to all templates
        // eslint-disable-next-line
        if (this._vm.router.currentRoute.name === 'template') {
          // eslint-disable-next-line
          this._vm.router.push('/templates');
        }
      }
       */
    },
    async getGoogleSheetsScreenshots({ state }, spreadsheetId) {
      const spreadsheetIdParam = spreadsheetId || state.dialogs.GSUrl.split('https://docs.google.com/spreadsheets/d/')[1];
      console.log(spreadsheetIdParam);
      // TODO - redo previewed html and where it's stored, should be under activeTemplate
      const template = storeUtils.collapseTemplate(state.activeTemplate);
      const previewData = {};
      state.previewModules.forEach((module) => {
        previewData[module.id] = module.previewCfg.previewHTML;
      });
      template.previewData = previewData;
      const response = await axios.post('/api/model/getGoogleSheetsScreenshots', {
        templateName: `${template.name}-${Date.now()}`,
        spreadsheetId: spreadsheetIdParam,
        template,
      }).catch((err) => {
        if (err.code === 'ECONNABORTED') {
          // Handle timeout error
          console.error('Request timed out');
          // Display a message to the user or retry the request
        } else {
          // Handle other errors
          console.error('An error occurred:', err);
        }
        state.activeTemplate.screenshotFileNames = [];
      });
      console.log(response);
      state.activeTemplate.screenshotFileNames = response.data;
      /*
      state.activeTemplate.screenshotFileNames = [
        'screenshot-00-1264207830.png',
        'screenshot-01-1412664858.png',
        'screenshot-02-1069629311.png',
        'screenshot-03-2028408941.png',
        'screenshot-04-600672681.png',
      ]; */
      // show dialog
      state.dialogs.showScreenshotsDialog = true;
    },
    startAutoSave({ rootState }) {
      // const isAutoSaved = true;
      // save once, e.g. if they just enabled autosave
      this.dispatch('saveRemoteTemplate');
      // this.dispatch('saveTemplate', isAutoSaved);
      // check if need to start autosave - maybe it's already there
      const { autoSavingInterval } = rootState;
      if (autoSavingInterval) {
        // clear previous autosave
        clearInterval(autoSavingInterval);
      }
      const saveInterval = setInterval(() => {
        if (rootState.activeTemplate && rootState.activeTemplate.data) {
          const savedAt = new Date().toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
          console.log(`... autosaving at ${savedAt}`);
          this.dispatch('updateState', {
            path: 'saving',
            value: true,
          });
          this.dispatch('saveRemoteTemplate');
        }
      }, 60 * 1000 * 1);
      this.dispatch('updateState', {
        path: 'autoSavingInterval',
        value: saveInterval,
      });
      console.log(`... autosave for template ${rootState.activeTemplate.name} started`);
    },
    /*
    saveTemplate({ dispatch, rootState }) {
      const template = JSON.parse(JSON.stringify(rootState.activeTemplate));
      const collapsedTemplate = storeUtils.collapseTemplate(template);
      collapsedTemplate.timestamp = Date.now();
      dispatch('saveRemoteTemplate', collapsedTemplate);
      // trigger html update
      // eslint-disable-next-line
      rootState.collapsedTemplate = collapsedTemplate;
    },
     */
    // eslint-disable-next-line
    async getStaticTemplate({ state, dispatch, rootState }, template) {
      // remove isLocked for users
      if (template.isLocked) {
        // eslint-disable-next-line
        template.isLocked = false;
      }
      // eslint-disable-next-line
      template = checkToUpgradeTemplate(template, rootState);
      // eslint-disable-next-line
      template = hydrateTemplate(template);
      // check if need to save
      // TODO - need this?
      const templateExists = rootState.user.templates.find((t) => t.uuid === template.uuid);
      if (!templateExists) {
        rootState.user.templates.unshift(template);
        dispatch('saveUser');
      }
      // TODO - unlikely to work
      dispatch('updateState', {
        path: 'activeTemplate',
        value: template,
      });
    },
    async addTemplate({ rootState }, newTemplate) {
      // this.dispatch('saveRemoteTemplateNow', newTemplate);
      rootState.user.templates.unshift(newTemplate);
      await this.dispatch('debouncedSaveRemoteTemplate', {
        template: newTemplate,
        skipPreviewUpdate: true,
      });
      // this.dispatch('saveUser');
    },
    // eslint-disable-next-line
    async getTemplate({ state, commit, dispatch, rootState }, data) {
      let template;

      const { templateId } = data;
      console.log(`... getting template ${templateId}`);
      const isLoadingDifferentTemplate = !rootState.activeTemplate || (rootState.activeTemplate
        && rootState.activeTemplate.uuid !== templateId);
      if (isLoadingDifferentTemplate) {
        // flush template
        // commit('updateState', {
        //   path: 'activeTemplate',
        //   value: null,
        // });
        // flush preview html
        // rootState.previewModules.forEach((previewModule) => {
        //   // eslint-disable-next-line
        //   previewModule.previewCfg.previewHTML = '';
        // });

        if (templateId === 'new') {
          // new template
          template = getDefaultTemplate(rootState);
        } else {
          if (typeof templateId === 'string') {
            // eslint-disable-next-line
            template = await dispatch('getTemplateByUUID', templateId);
            if (!template) {
              // eslint-disable-next-line
              // TODO - improve translate
              alert(mixin.methods.translate('ui_template_not_found', null, rootState));
              // eslint-disable-next-line
              window.location.replace('/builder/#/templates');
            }
            // const checks = this.checkToUpgradeTemplate(template, state);
            // template = checks.template;
          } else {
            // object, static template
            template = templateId;
            // remove isLocked
            if (template.isLocked) {
              template.isLocked = false;
            }
          }
          template = checkToUpgradeTemplate(template, rootState);
          // log requested template
          dispatch('log', template || { error: `template ${templateId} not found` });
        }

        template = hydrateTemplate(template);

        if (templateId === 'new') {
          dispatch('addTemplate', template);
        }


        // reset isGenerating status if was interrupted
        if (template.isGenerating === 'progress') {
          template.isGenerating = 'done';
        }

        // unlock if need to
        if (template.isLocked) {
          template.isLocked = false;
        }

        // eslint-disable-next-line
        rootState.error = null; // need this ?

        // check if need to save
        // TODO - shouldn't work as we are saving templates differently ??
        // TODO - don't need to save if is about to generate a new template ?? need to save after!
        // const templateExists = rootState.user.templates.find((t) => t.uuid === template.uuid);
        // if (!templateExists) {
        //   rootState.user.templates.unshift(template);
        //   this.dispatch('saveUser');
        // }
        // TODO - ???
        // eslint-disable-next-line
        rootState.dialogs.showScreenshotsDialog = false;
      }

      // update page url, if new
      // eslint-disable-next-line
      const currentRouterId = this._vm.router.currentRoute.params.id;
      if (currentRouterId !== template.uuid) {
        // eslint-disable-next-line
        this._vm.router.replace(`/template/${template.uuid}`);
      }

      // update page title
      if (template.name) {
        commit('updatePageTitle', template.name);
      }

      Vue.set(rootState.activeTemplate.data, 'activeSectionId', template.data.activeSectionId);
      Vue.set(rootState.activeTemplate.data, 'sections', template.data.sections);
      Vue.set(rootState.activeTemplate.data, 'coreResources', template.data.coreResources);
      Vue.set(rootState.activeTemplate.data, 'divisions', template.data.divisions);
      Vue.set(rootState.activeTemplate.data, 'env', template.data.env);
      Vue.set(rootState.activeTemplate.data, 'defaultFormulaId', template.data.defaultFormulaId);
      Vue.set(rootState.activeTemplate.data, 'formulas', template.data.formulas);
      Vue.set(rootState.activeTemplate.data, 'options', template.data.options);
      Vue.set(rootState.activeTemplate.data, 'openAIPrompt', template.data.openAIPrompt);
      Vue.set(rootState.activeTemplate, 'layout', template.layout);
      Vue.set(rootState.activeTemplate, 'debug', template.debug);
      Vue.set(rootState.activeTemplate, 'uuid', template.uuid);
      Vue.set(rootState.activeTemplate, 'isNavigatorVisible', template.isNavigatorVisible);
      Vue.set(rootState.activeTemplate, 'name', template.name);
      Vue.set(rootState.activeTemplate, 'description', template.description);
      Vue.set(rootState.activeTemplate, 'isGenerating', template.isGenerating);
      Vue.set(rootState.activeTemplate, 'showOnboardingDialog', template.showOnboardingDialog);
      Vue.set(rootState.activeTemplate, 'timestamp', template.timestamp);
      Vue.set(rootState.activeTemplate, 'language', template.language);
      rootState.activeTemplate.data.modules.forEach((m) => {
        const templateModule = template.data.modules.find((tm) => tm.id === m.id);
        Vue.set(m, 'isEnabled', templateModule.isEnabled);
        Vue.set(m, 'isInitialized', templateModule.isInitialized);
        Vue.set(m.previewCfg, 'previewHTML', templateModule.previewCfg.previewHTML);
        Vue.set(m.previewCfg, 'isUpdating', templateModule.previewCfg.isUpdating);
      });

      // if (isLoadingDifferentTemplate && template.isGenerating !== 'init') {
      //   this.dispatch('previewModel');
      // }

      // start autosave
      // this.dispatch('startAutoSave');

      // enable editing tools
      if (rootState.mode !== 'static') {
        // eslint-disable-next-line
        rootState.isEditingToolsVisible = true;
      }
    },
    debouncedPreviewModel: debounce(async ({ commit, rootState }) => {
      const { modules } = rootState.activeTemplate.data;
      if (rootState.activeTemplate.isGenerating !== 'progress') {
        modules.forEach((module) => {
          // eslint-disable-next-line
          module.previewCfg.isUpdating = !module.mappedToSection || module.mappedToSection.isEnabled ? true : false;
        });
      }
      commit('updateState', {
        path: 'activeTemplate.data.modules',
        value: modules,
      });

      const collapsedTemplate = storeUtils.collapseTemplate(rootState.activeTemplate);
      collapsedTemplate.debug.showStyles = true;
      const buildResult = await axios.post('/api/model/build', {
        template: collapsedTemplate,
        isPreview: true,
      }).catch((err) => {
        console.dir(err);
      });
      const fileName = buildResult.data;
      if (fileName) {
        const columnCount = Number(rootState.activeTemplate.layout.cFcstColCount) + 9;
        const response = await axios.post('/api/model/build', {
          fileName,
          columnCount,
        }).catch((err) => {
          console.dir(err);
        });

        // update preview data
        // update DOM with html
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const formatterPercent = new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });
        modules.forEach((module, index) => {
          // TODO - make it a flag
          if (module.id !== 'module_name_assumptions') {
            const rawSectionHTML = response.data[module.id];
            if (rawSectionHTML) {
              let rowsArr = rawSectionHTML.split(/<\/tr>/g);
              rowsArr = rowsArr.map((row) => {
                let arr = row.split(/(>-?\d+\.?[\dE-]*?<)/);
                if (arr.length > 1) {
                  // eslint-disable-next-line
                  arr = arr.map((item) => {
                    let result = item;
                    if (result.match(/>-?\d+\.?[\dE-]*?</g)) {
                      result = result.replace(/[><]/g, '');
                      // eslint-disable-next-line
                      if (!isNaN(result)) {
                        const dateRowsSelectors = ['inputStartDate', 'contentIndent0date'];
                        const percentRowsSelectors = ['"contentIndent0percent"', 'contentGrowth0'];
                        if (dateRowsSelectors.some((selector) => row.includes(selector))) {
                          // date
                          const dateInMs = Number(result) * 1000 * 60 * 60 * 24;
                          const epochFrom1900inMS = 2209075200000;
                          const dateInJsMs = dateInMs - epochFrom1900inMS;
                          result = `>${new Date(dateInJsMs).toLocaleDateString()}<`;
                        } else if (percentRowsSelectors.some((selector) => row.includes(selector))) {
                          // percent
                          result = `>${formatterPercent.format(result)}<`;
                        } else {
                          // number
                          if (Math.abs(result) < 1e-3) {
                            result = 0;
                          }
                          result = `>${formatter.format(result)}<`;
                        }
                      }
                    }
                    return result;
                  });
                }
                // eslint-disable-next-line
                row = arr.join('');
                return row;
              });
              // eslint-disable-next-line
              module.previewCfg.previewHTML = rowsArr.join('</tr>');
              // eslint-disable-next-line
              // rootState.activeTemplate.data.modules = Object.assign({}, rootState.activeTemplate.data.modules, ...module);
              // Vue.set(rootState.activeTemplate.data.modules, index, module);
              // eslint-disable-next-line
              // rootState.activeTemplate.data.modules[index] = { ...rootState.activeTemplate.data.modules[index], ...module };
            } else {
              console.warn(`... html for ${module.id} not found`);
            }
            // eslint-disable-next-line
            module.previewCfg.isUpdating = false;
            commit('updateModuleHTML', {
              index,
              updatedModule: module,
            });
          }
        });
        setTimeout(() => {
          // eslint-disable-next-line
          rootState.isPreviewDataLoaded = true;
          console.log('... preview loaded');
        }, 0);
      } else {
        alert('Error loading preview');
      }
    }, 10000),
    // eslint-disable-next-line
    async previewModel({ commit, rootState }) {
      const { modules } = rootState.activeTemplate.data;
      if (rootState.activeTemplate.isGenerating !== 'progress') {
        modules.forEach((module) => {
          // eslint-disable-next-line
          module.previewCfg.isUpdating = !module.mappedToSection || module.mappedToSection.isEnabled ? true : false;
        });
      }
      commit('updateState', {
        path: 'activeTemplate.data.modules',
        value: modules,
      });

      const collapsedTemplate = storeUtils.collapseTemplate(rootState.activeTemplate);
      collapsedTemplate.debug.showStyles = true;
      const buildResult = await axios.post('/api/model/build', {
        template: collapsedTemplate,
        isPreview: true,
      }).catch((err) => {
        console.dir(err);
      });
      const fileName = buildResult.data;
      if (fileName) {
        const columnCount = Number(rootState.activeTemplate.layout.cFcstColCount) + 9;
        const response = await axios.post('/api/model/build', {
          fileName,
          columnCount,
        }).catch((err) => {
          console.dir(err);
        });

        // update preview data
        // update DOM with html
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const formatterPercent = new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });
        modules.forEach((module, index) => {
          // TODO - make it a flag
          if (module.id !== 'module_name_assumptions') {
            const rawSectionHTML = response.data[module.id];
            if (rawSectionHTML) {
              let rowsArr = rawSectionHTML.split(/<\/tr>/g);
              rowsArr = rowsArr.map((row) => {
                let arr = row.split(/(>-?\d+\.?[\dE-]*?<)/);
                if (arr.length > 1) {
                  // eslint-disable-next-line
                  arr = arr.map((item) => {
                    let result = item;
                    if (result.match(/>-?\d+\.?[\dE-]*?</g)) {
                      result = result.replace(/[><]/g, '');
                      // eslint-disable-next-line
                      if (!isNaN(result)) {
                        const dateRowsSelectors = ['inputStartDate', 'contentIndent0date'];
                        const percentRowsSelectors = ['"contentIndent0percent"', 'contentGrowth0'];
                        if (dateRowsSelectors.some((selector) => row.includes(selector))) {
                          // date
                          const dateInMs = Number(result) * 1000 * 60 * 60 * 24;
                          const epochFrom1900inMS = 2209075200000;
                          const dateInJsMs = dateInMs - epochFrom1900inMS;
                          result = `>${new Date(dateInJsMs).toLocaleDateString()}<`;
                        } else if (percentRowsSelectors.some((selector) => row.includes(selector))) {
                          // percent
                          result = `>${formatterPercent.format(result)}<`;
                        } else {
                          // number
                          if (Math.abs(result) < 1e-3) {
                            result = 0;
                          }
                          result = `>${formatter.format(result)}<`;
                        }
                      }
                    }
                    return result;
                  });
                }
                // eslint-disable-next-line
                row = arr.join('');
                return row;
              });
              // eslint-disable-next-line
              module.previewCfg.previewHTML = rowsArr.join('</tr>');
              // eslint-disable-next-line
              // rootState.activeTemplate.data.modules = Object.assign({}, rootState.activeTemplate.data.modules, ...module);
              // Vue.set(rootState.activeTemplate.data.modules, index, module);
              // eslint-disable-next-line
              // rootState.activeTemplate.data.modules[index] = { ...rootState.activeTemplate.data.modules[index], ...module };
            } else {
              console.warn(`... html for ${module.id} not found`);
            }
            // eslint-disable-next-line
            module.previewCfg.isUpdating = false;
            commit('updateModuleHTML', {
              index,
              updatedModule: module,
            });
          }
        });
        setTimeout(() => {
          // eslint-disable-next-line
          rootState.isPreviewDataLoaded = true;
          console.log('... preview loaded');
        }, 0);
      } else {
        alert('Error loading preview');
      }
    },
    async cloneTemplate({ dispatch, rootState }, template) {
      // check to see if template to be cloned is fully loaded
      let templateToClone;
      if (template.isSummary) {
        templateToClone = await dispatch('getRemoteTemplate', template.uuid);
      } else {
        templateToClone = JSON.parse(JSON.stringify(template));
      }
      // eslint-disable-next-line
      templateToClone.uuid = storeUtils.uuidv4();
      templateToClone.timestamp = Date.now();
      templateToClone.name = `${templateToClone.name} - ${mixin.methods.translate('ui_clone_btn', null, rootState)}`;
      const result = await dispatch('saveRemoteTemplateNow', templateToClone);
      return result;
    },
    async publishTemplate({ state, dispatch }) {
      const { isPublished } = state.activeTemplate;
      const data = {
        uuid: state.activeTemplate.uuid,
        name: state.activeTemplate.name,
        isPublished,
      };
      await axios.post('/api/template/publish', data);
      dispatch('saveRemoteTemplate');
    },
    async downloadModel({ commit, rootState }, isGoogleSheets) {
      this.dispatch('updateState', {
        path: isGoogleSheets ? 'buildingGS' : 'building',
        value: true,
      });
      const collapsedTemplate = storeUtils.collapseTemplate(rootState.activeTemplate);
      const response = await axios.post('/api/model/build', {
        template: collapsedTemplate,
        isGoogleSheets,
      }).catch((err) => {
        console.dir(err);
      });
      if (!response || !response.data) {
        // eslint-disable-next-line
        alert('Something went wrong');
      } else {
        // eslint-disable-next-line
        if (isGoogleSheets) {
          commit('updateState', {
            path: 'dialogs.GSUrl',
            value: response.data,
          });
          commit('updateState', {
            path: 'dialogs.showGSUrlDialogVisible',
            value: true,
          });
        } else {
          // downloading file
          const form = document.createElement('form');
          form.method = 'GET';
          form.action = '/api/model/download';
          const input = document.createElement('input');
          input.name = 'filename';
          input.value = response.data;
          form.appendChild(input);
          document.body.appendChild(form);
          form.submit();
          form.parentElement.removeChild(form);
        }
        // show message
        if (!rootState.loggedin && rootState.user.settings.showLoginReminder) {
          this.dispatch('updateState', {
            path: 'dialogs.snackbar',
            value: true,
          });
          const interval = setInterval(() => {
            // eslint-disable-next-line
            rootState.loginReminderProgressCurrentValue -= 1;
          }, 1000);
          setTimeout(() => {
            clearInterval(interval);
            // eslint-disable-next-line
            rootState.loginReminderProgressCurrentValue = rootState.loginReminderProgressInitValue;
          }, rootState.loginReminderProgressInitValue * 1000);
        }
      }

      // eslint-disable-next-line
      this.dispatch('updateState', {
        path: isGoogleSheets ? 'buildingGS' : 'building',
        value: false,
      });
    },
    // eslint-disable-next-line
    async getRemoteTemplate({ rootState }, templateId) {
      // eslint-disable-next-line
      const userId = rootState.user._id;
      const response = await axios.get(`/api/user/${userId}/template/${templateId}`).catch((err) => {
        console.dir(err);
      });
      return response.data;
    },
    // eslint-disable-next-line
    async saveRemoteTemplateNow({}, template) {
      await axios.post(`/api/template/${template.uuid}`, { template });
    },
    debouncedSaveRemoteTemplate: debounce(async ({ dispatch, commit, rootState }, { template, skipPreviewUpdate }) => {
      const templateToSave = template || storeUtils.collapseTemplate(rootState.activeTemplate);
      templateToSave.timestamp = Date.now();
      // save locally or remotely
      console.log('... saving template');
      // eslint-disable-next-line
      const userId = rootState.user._id;
      const response = await axios.post(`/api/user/${userId}/template/${templateToSave.uuid}`, { template: templateToSave });
      // if success, update local templates
      if (response.data) {
        const localTemplates = rootState.user.templates;
        const localTemplateIndex = localTemplates.findIndex((t) => t.uuid === templateToSave.uuid);
        if (localTemplateIndex !== -1) {
          localTemplates[localTemplateIndex] = templateToSave;
        }
        commit('updateState', {
          path: 'user.templates',
          value: localTemplates,
        });
      }
      console.log(response);
      if (!skipPreviewUpdate) {
        // update preview
        dispatch('previewModel');
      }
      return response;
    }, 2000),
    async saveRemoteTemplate({ dispatch }, template) {
      // template would only come from cloning
      dispatch('debouncedSaveRemoteTemplate', { template });
    },
    async getTemplateByUUID({ rootState, dispatch }, templateId) {
      let template = null;
      template = rootState.user.templates.find((t) => t.uuid === templateId);
      if (template) {
        // if template summary, try loading from remote
        if (template.isSummary) {
          template = dispatch('getRemoteTemplate', templateId);
        }
      }

      if (!template) {
        // try loading from remote
        template = await dispatch('getRemoteTemplate', templateId);
      }

      // if not found, search gallery templates
      if (!template) {
        template = rootState.templateGallery.find((t) => t.uuid === templateId);
        if (template) {
          template.timestamp = Date.now();
          delete template.uuid;
          // const checks = this.checkToUpgradeTemplate(template, state);
          // template = checks.template;
        }
      }
      return template;
    },
  },
  getters: {},
};
